import type { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const ArtistPalette: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      // eslint-disable-next-line max-len
      d="M9.99899 5.3125C9.87233 5.3125 9.76983 5.415 9.77149 5.54167C9.77149 5.66833 9.87399 5.77083 10.0007 5.77083C10.1273 5.77083 10.2298 5.66833 10.2298 5.54167C10.2282 5.415 10.1265 5.3125 9.99899 5.3125"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      // eslint-disable-next-line max-len
      d="M5.77042 9.99899C5.77042 9.87233 5.66792 9.76983 5.54208 9.77149C5.41542 9.77149 5.31292 9.87399 5.31292 10.0007C5.31292 10.1273 5.41542 10.2298 5.54208 10.2298C5.66875 10.2298 5.77042 10.1265 5.77042 9.99899"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      // eslint-disable-next-line max-len
      d="M13.3139 6.68422C13.2247 6.59505 13.0797 6.59505 12.9914 6.68505C12.9022 6.77422 12.9022 6.91922 12.9914 7.00839C13.0805 7.09755 13.2255 7.09755 13.3147 7.00839C13.4039 6.91839 13.4039 6.77422 13.3139 6.68422"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      // eslint-disable-next-line max-len
      d="M7.00919 12.9909C6.92003 12.9017 6.77503 12.9017 6.68669 12.9917C6.59753 13.0809 6.59753 13.2259 6.68669 13.315C6.77586 13.4042 6.92086 13.4042 7.01003 13.315C7.09919 13.2259 7.09919 13.0809 7.00919 12.9909"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      // eslint-disable-next-line max-len
      d="M7.00849 7.00919C7.09766 6.92003 7.09766 6.77503 7.00766 6.68669C6.91849 6.59753 6.77349 6.59753 6.68432 6.68669C6.59516 6.77586 6.59516 6.92086 6.68432 7.01003C6.77349 7.09919 6.91849 7.09919 7.00849 7.00919"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M9.99962 17.4996C5.78712 17.4996 2.38546 14.0263 2.50296 9.78712C2.61129 5.87379 5.87379 2.61129 9.78712 2.50296C14.0263 2.38546 17.4996 5.78712 17.4996 9.99962V10.833C17.4996 11.7538 16.7538 12.4996 15.833 12.4996H14.1138C13.0063 12.4996 12.2071 13.5596 12.5113 14.6238L12.7255 15.3746C13.0305 16.4396 12.2305 17.4996 11.1238 17.4996H9.99962Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
